import { ApiRequest } from 'src/models/api.request';
import VwDatagridpropsDTO from 'src/models/Genel/VwDatagridpropsDTO';
import api from 'src/services/core/api';
import { ApiResponse } from '../core';

const controllerName = 'VwDatagridpropsDTO';

export const dataGridApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDataGridProps: builder.query<
      Array<VwDatagridpropsDTO>,
      { kullaniciId: number; datarGridId: string }
    >({
      query: (request) => {
        var apiRequest: ApiRequest<VwDatagridpropsDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              {
                fieldName: 'kullaniciId',
                operator: '=',
                value1: request.kullaniciId
              },
              {
                fieldName: 'datagridId',
                operator: '=',
                value1: request.datarGridId
              }
            ]
          },
          // sorts: [
          //     { fieldName: "tarih", ascending: false }
          // ],
          paging: false
        };

        return {
          url: controllerName + '/find',
          method: 'POST',
          body: JSON.stringify(apiRequest)
        };
      }
    }),
    updateDataGridProps: builder.mutation<
      ApiResponse<VwDatagridpropsDTO>,
      VwDatagridpropsDTO
    >({
      query: (request) => ({
        url: controllerName,
        method: 'PUT',
        body: JSON.stringify(request)
      })
    }),
    crateDataGridProps: builder.mutation<
      ApiResponse<VwDatagridpropsDTO>,
      VwDatagridpropsDTO
    >({
      query: (request) => ({
        url: controllerName,
        method: 'POST',
        body: JSON.stringify(request)
      })
    }),
    deleteDataGridProps: builder.mutation<
      ApiResponse<VwDatagridpropsDTO>,
      number
    >({
      query: (request) => ({
        url: controllerName + "/" + request,
        method: 'DELETE'
      })
    })
  })
});

export const {
    useCrateDataGridPropsMutation,
    useGetDataGridPropsQuery,
    useUpdateDataGridPropsMutation,
    useDeleteDataGridPropsMutation
} = dataGridApi;
